export default __webpack_public_path__ + "static/media/image_Workspace_black_gray.0f6a5858.svg";